import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import {
  Dialog,
  Tab,
  Tabs,
  KeyCombo,
  Classes
} from "@blueprintjs/core";
import classNames from "classnames";
import {
  getHotkeyProps
} from "../utils/hotkeyUtils";
import "./style.css";
export default function HotkeysDialog(props) {
  if (!props.hotkeySets) {
    console.error("Missing hotkeySets in HotkeysDialog");
    return null;
  }
  const sections = Object.keys(props.hotkeySets);
  return /* @__PURE__ */ jsx(
    Dialog,
    {
      isOpen: props.isOpen,
      onClose: props.onClose,
      title: props.dialogTitle || "Keyboard Shortcuts",
      children: /* @__PURE__ */ jsx(Tabs, { className: "tg-hotkeys-dialog", children: sections.map((name) => /* @__PURE__ */ jsx(
        Tab,
        {
          id: name,
          title: sections.length === 1 ? void 0 : name,
          panel: /* @__PURE__ */ jsx("div", { className: "tg-table-wrapper", children: /* @__PURE__ */ jsxs(
            "table",
            {
              className: classNames(
                Classes.HTML_TABLE,
                Classes.HTML_TABLE_STRIPED,
                Classes.HTML_TABLE_BORDERED
              ),
              children: [
                /* @__PURE__ */ jsx("thead", { children: /* @__PURE__ */ jsxs("tr", { children: [
                  /* @__PURE__ */ jsx("th", { children: "Action" }),
                  /* @__PURE__ */ jsx("th", { children: "Shortcut" })
                ] }) }),
                /* @__PURE__ */ jsx("tbody", { children: Object.keys(props.hotkeySets[name]).map((id) => {
                  const def = getHotkeyProps(
                    props.hotkeySets[name][id],
                    id
                  );
                  return /* @__PURE__ */ jsxs("tr", { children: [
                    /* @__PURE__ */ jsx("td", { children: def.label }),
                    /* @__PURE__ */ jsx("td", { children: /* @__PURE__ */ jsx(KeyCombo, { combo: def.combo }) })
                  ] }, id);
                }) })
              ]
            }
          ) })
        },
        name
      )) })
    }
  );
}
